/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DependentResourcesListResponse {
    getFixupPrototypeFunction() { return DependentResourcesListResponse.fixupPrototype; }

    static newInstance(model: Partial<DependentResourcesListResponse>): DependentResourcesListResponse {
        let obj = Object.assign(new DependentResourcesListResponse(), model);
        DependentResourcesListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DependentResourcesListResponse>): DependentResourcesListResponse {
        if (!model) return null;
        return DependentResourcesListResponse.newInstance(<DependentResourcesListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DependentResourcesListResponse) {
        if (!obj) return;

        models.DependentResourcesListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DependentResourcesListResponse): boolean {
        Object.setPrototypeOf(obj, DependentResourcesListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Resource name for which associated resources are captured.
     */
    resource_name: string;

    /**
     * Associated resources
     */
    dependent_resources: any;

}
